import usibrasGhanaCover from "assets/img/auth/usibras_ghana_limited_cover.jpeg";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
// import FixedPlugin from "components/fixedPlugin/FixedPlugin"; // Commented out import
import SignIn from "views/auth/SignIn";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className="relative h-full w-full">
      <main className="mx-0 h-full min-h-screen">
        <div className="relative flex h-full w-full">
          {/* Left side with form */}
          <div className="flex w-full flex-col lg:w-[75%] lg:px-8 xl:w-[60%] xl:px-0 xl:pl-[70px]">
            <Link to="/auth/departments" className="mt-4 ml-4 w-max lg:mt-10">
              <div className="flex items-center hover:cursor-pointer">
                <svg
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.70994 2.11997L2.82994 5.99997L6.70994 9.87997C7.09994 10.27 7.09994 10.9 6.70994 11.29C6.31994 11.68 5.68994 11.68 5.29994 11.29L0.709941 6.69997C0.319941 6.30997 0.319941 5.67997 0.709941 5.28997L5.29994 0.699971C5.68994 0.309971 6.31994 0.309971 6.70994 0.699971C7.08994 1.08997 7.09994 1.72997 6.70994 2.11997V2.11997Z"
                    fill="#A3AED0"
                  />
                </svg>
                <p className="ml-3 text-sm text-gray-600">Back to Department</p>
              </div>
            </Link>

            <div className="flex-grow pl-4">
              {/* <div className="absolute top-32 mb-8 flex items-center gap-4">
                <img 
                  src={require("assets/img/auth/usibras_ghana_limited_logo.jpeg")} 
                  alt="Usibras Ghana Logo" 
                  className="h-16 w-16 object-contain"
                />
                <h1 className="text-3xl font-bold text-navy-700 dark:text-white">
                  USIBRAS GHANA LTD
                  
                </h1>
              </div> */}
              <Routes>
                {getRoutes(routes)}
                <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
                <Route path="/sign-in" element={<SignIn />} />
              </Routes>
            </div>
          </div>

          {/* Right side with image */}
          <div className="absolute right-0 hidden h-full min-h-screen md:block lg:w-[45vw] 2xl:w-[40vw]">
            <div
              className="absolute flex h-full w-full items-center justify-center bg-cover bg-center bg-no-repeat lg:rounded-bl-[120px] xl:rounded-bl-[200px]"
              style={{ backgroundImage: `url(${usibrasGhanaCover})` }}
            />
          </div>
        </div>
      </main>
      {/* <FixedPlugin /> */} {/* Commented out component */}
    </div>
  );
}
